export default __webpack_public_path__ + "static/media/coaches-header.7f18e78c.jpg";